import { TApiResponse } from '@/common/types/response';

import { TEventsCardState } from './types';

export function setEventCard(state: TEventsCardState, res: TApiResponse<TEventsCardState['dataCardEvent']>) {
  state.dataCardEvent = res.data;
}
